import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { CustomSearchBarConfig } from '@app/models';

@Component({
    selector: 'app-search-bar',
    templateUrl: './search-bar.component.html',
    styleUrls: ['./search-bar.component.scss'],
    standalone: false
})
export class SearchBarComponent implements OnInit {

  @Input() customSearchBarConfig: CustomSearchBarConfig = {
    input: {
      value: '',
      placeholder: 'Search'
    }
  };
  @Input('disabled') disabled: boolean = false;
  @Output() customSearchBarConfigChange: EventEmitter<CustomSearchBarConfig> = new EventEmitter<CustomSearchBarConfig>();
  @ViewChild('trigger', { static: false }) autocompleteTrigger!: MatAutocompleteTrigger;
  @ViewChild('searchInput', { static: false }) searchInputRef!: ElementRef<HTMLInputElement>;
  
  onModelChange() {
    this.customSearchBarConfigChange.emit(this.customSearchBarConfig);
  }

  @Output('searchAction') searchAction: EventEmitter<string> = new EventEmitter<string>();
  private readonly _searchAutoComplete: string[] = [];

  constructor() { 
    if (!this.customSearchBarConfig.selectedSearchByOptions && this.customSearchBarConfig.searchByOptions?.length) {
      this.customSearchBarConfig.selectedSearchByOptions = this.customSearchBarConfig.searchByOptions[0];
      this.onModelChange();
    }
  }

  ngOnInit(): void {
    // no initial operations required
  }

  selectSearchByOption(index: number) {
    if (this.customSearchBarConfig.searchByOptions?.length) {
      this.customSearchBarConfig.selectedSearchByOptions = this.customSearchBarConfig.searchByOptions[index];
      this.onModelChange();
    }
  }

  emitSearchAction(isEnterKey: boolean = false) {
    if (this.customSearchBarConfig.input.value.trim() !== '' && !this._searchAutoComplete.includes(this.customSearchBarConfig.input.value))
        this._searchAutoComplete.push(this.customSearchBarConfig.input.value);
    
    // Close autocomplete cache list when Enter is pressed
    if (isEnterKey) {
      if (this.autocompleteTrigger) {
        this.autocompleteTrigger.closePanel();
      }
      if (this.searchInputRef?.nativeElement) {
        this.searchInputRef.nativeElement.blur();
      }
    }
    
    this.searchAction.emit();
  }

  resetAction() {
    this.customSearchBarConfig.input.value = '';
    this.selectSearchByOption(0);
    this.emitSearchAction();
  }

  preventEventAction(event: any) {
    if (event) {
      event.preventDefault();
    }
    return false;
  }

  get searchAutoComplete(): string[] {
      return this._searchAutoComplete.slice(Math.max(this._searchAutoComplete.length - 5, 0));
  }

}
